import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ArrowDownSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.995 22a1.45 1.45 0 01-1.026-.419l-6.494-6.34c-.644-.564-.6-1.596-.065-2.178.546-.593 1.54-.675 2.129-.041l3.964 3.865V3.534C10.503 2.695 11.165 2 12 2c.835 0 1.497.695 1.497 1.534v13.353l3.964-3.865c.59-.634 1.58-.552 2.126.04.535.582.586 1.603-.06 2.177l-6.495 6.341a1.53 1.53 0 01-1.037.42z", fill: "currentColor" })] })));
};

export { ArrowDownSolidIcon };
//# sourceMappingURL=ArrowDownSolidIcon.js.map
